import { render, staticRenderFns } from "./assignEmrClinicToDoctor.vue?vue&type=template&id=762b9de4&"
import script from "./assignEmrClinicToDoctor.vue?vue&type=script&lang=js&"
export * from "./assignEmrClinicToDoctor.vue?vue&type=script&lang=js&"
import style0 from "./assignEmrClinicToDoctor.vue?vue&type=style&index=0&id=762b9de4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports